import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useCurrency } from "@/contexts/CurrencyContext";
import { CURRENCY_LIST, type CurrencyCode } from "@/lib/currency";

export function CurrencySwitcher() {
  const { currency, setCurrency, ratesLoading } = useCurrency();

  return (
    <Select value={currency} onValueChange={(v) => setCurrency(v as CurrencyCode)} disabled={ratesLoading}>
      <SelectTrigger className="w-auto gap-1.5 border-none shadow-none h-9 text-sm">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {CURRENCY_LIST.map((c) => (
          <SelectItem key={c.code} value={c.code}>
            {c.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
